var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.1562,
  cy: 12,
  r: 9,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4281_129127)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.33789,
  y: 2.18164,
  width: 19.6364,
  height: 19.6364,
  fill: "#038F00"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0765 9.40716C15.7581 9.06414 15.2301 9.0588 14.9053 9.3962L11.2482 13.1958L9.40711 11.283C9.08235 10.9456 8.55439 10.951 8.23591 11.294C7.92535 11.6285 7.92963 12.1605 8.24627 12.4895L11.2482 15.6083L16.0662 10.6026C16.3828 10.2737 16.3871 9.74166 16.0765 9.40716Z",
  fill: "white"
});

function SvgGroup123423(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4281_129127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _ref2), _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup123423);
export default __webpack_public_path__ + "static/media/group-123423.c4c71baf.svg";
export { ForwardRef as ReactComponent };